/**
 * HoverTooltip Component
 * Displays tooltip information when hovering over map elements
 */

import { HoverInfo } from "@/util/http/WeevilTrak/responseType";
import React from "react";
import dayjs from "dayjs";
import "./hovertooltip.css";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(advancedFormat);

interface HoverTooltipProps {
    hoverInfo: HoverInfo | null;
}

export const HoverTooltip: React.FC<HoverTooltipProps> = ({ hoverInfo }) => {
    if (!hoverInfo) return null;

    const tooltipStyle: React.CSSProperties = {
        position: "fixed",
        left: (hoverInfo.mouseX ?? 0) + 15,
        top: (hoverInfo.mouseY ?? 0) - 10,
        zIndex: 10001,
        backgroundColor: "white",
        padding: "12px",
        borderRadius: "5px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        minWidth: "200px",
        maxWidth: "300px",
        fontSize: "13px",
        pointerEvents: "none",
        display: "block",
        visibility: "visible",
        opacity: 1,
        wordWrap: "break-word",
        overflowWrap: "break-word",
        hyphens: "auto",
        textAlign: "left",
    };

    const rowStyle: React.CSSProperties = {
        marginBottom: "4px",
        color: "#333",
        wordWrap: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "normal",
        textAlign: "left",
    };

    const labelStyle: React.CSSProperties = {
        fontWeight: 700,
        marginRight: "4px"
    };

    return (
        <div className="tooltip" style={tooltipStyle}>
            {hoverInfo.isCenter ? (
                <>
                    <div className="tooltipRow" style={rowStyle}>
                        <span style={labelStyle}>Location:</span> {`${hoverInfo?.locationName}`}
                    </div>
                    <div className="tooltipRow" style={rowStyle}>
                        <span style={labelStyle}>Predicted Stage Date:</span> {hoverInfo?.predictedStageDate ? dayjs(hoverInfo.predictedStageDate).format("MMMM Do, YYYY") : ""}
                    </div>
                    <div className="tooltipRow" style={rowStyle}>
                        <span style={labelStyle}>Days to Enter Stage {hoverInfo?.stage}:</span> {
                            hoverInfo?.value?.toFixed(2) === "0.00" || hoverInfo?.value?.toFixed(0) === "0" ? "N/A" : `${hoverInfo?.value?.toFixed(0)}`
                        } days
                    </div>
                </>
            ) : (
                <>
                    <div className="tooltipRow" style={rowStyle}>
                        <span style={labelStyle}>Location:</span> {`${hoverInfo.lng.toFixed(4)}, ${hoverInfo.lat.toFixed(4)}`}
                    </div>
                    <div className="tooltipRow" style={rowStyle}>
                        <span style={labelStyle}>Predicted Stage Date:</span> {hoverInfo?.predictedStageDate ? dayjs(hoverInfo.predictedStageDate).format("MMMM Do, YYYY") : ""}
                    </div>
                    <div className="tooltipRow" style={rowStyle}>
                        <span style={labelStyle}>Days to Enter Stage {hoverInfo?.stage}:</span> {
                            hoverInfo?.value?.toFixed(2) === "0.00" || hoverInfo?.value?.toFixed(0) === "0" ? "N/A" : `${hoverInfo?.value?.toFixed(0)}`
                        } days
                    </div>

                </>
            )}
        </div>
    );
};
